import { render, staticRenderFns } from "./the-client-filter.vue?vue&type=template&id=043913e3&scoped=true&"
import script from "./the-client-filter.vue?vue&type=script&lang=js&"
export * from "./the-client-filter.vue?vue&type=script&lang=js&"
import style0 from "./the-client-filter.vue?vue&type=style&index=0&id=043913e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043913e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
